import React, { PropsWithChildren } from "react";
//#region types
import { WizardFormSectionContainerProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import WizardStepContextProvider from "./wizardStep/contextProvider";
//#endregion

const WizardFormSectionContainer: React.FC<PropsWithChildren<WizardFormSectionContainerProps>> = (props) => {
  const { wizardProps } = props;

  React.useEffect(() => {
    wizardProps.setStepCount(props.children?.filter((c) => c).length ?? 0);
  }, [props.children]);

  return (
    <>
      {props.children
        ?.filter((c) => c)
        .map((childElem, index) =>
          childElem ? (
            <WizardStepContextProvider key={index} index={index}>
              {childElem}
            </WizardStepContextProvider>
          ) : (
            <React.Fragment key={index} />
          )
        )}
    </>
  );
};

export default WizardFormSectionContainer;
